<template>
	<!-- <AppLoadBar /> -->
	<RouterView v-slot="{ Component, route }">
		<template v-if="Component">
			<!-- <Transition mode="out-in"> -->

			<div
				class="layout"
				:class="[typeof route.meta.background === 'function' ? route.meta.background() : route.meta.background]"
			>
				<component :is="route.meta.layout || AuthLayout">
					<KeepAlive :exclude="excludedRoutes">
						<Suspense timeout="0">
							<component :is="Component" />
							<template #fallback><div class="loading-animation"></div></template>
						</Suspense>
					</KeepAlive>
				</component>

				<BottomMenu v-if="route.meta.menu && walletStore.isLogin" />
				<AppToaster />
			</div>

			<!-- </Transition> -->
		</template>
	</RouterView>
	<AppModal />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import AppModal from '@/components/AppModal.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import { useTelegram } from './composables/useTelegram';
import { WEBAPP_API_MIN_VERSION } from './constants';
import BottomMenu from './views/MainView/BottomMenu.vue';
import AppToaster from '@/features/toasts/components/AppToaster.vue';
import { useWalletStore } from './stores/useWalletStore';

const { telegram } = useTelegram();
const router = useRouter();
const walletStore = useWalletStore();

if (!telegram.WebApp.isVersionAtLeast(WEBAPP_API_MIN_VERSION)) {
	router.replace('/unsupported');
}

try {
	telegram.WebApp.expand();
	telegram.WebApp.disableVerticalSwipes();
	telegram.WebApp.setHeaderColor('#020916');
	telegram.WebApp.setBackgroundColor('#020916');
} catch (error) {
	console.error(error);
}

const excludedRoutes = computed(() => {
	return router
		.getRoutes()
		.filter((route) => typeof route.meta.excludeKeepAlive === 'string')
		.map((route) => route.meta.excludeKeepAlive!);
});
</script>

<style scoped>
.layout {
	width: 100%;
	height: 100%;

	display: flex;
	flex-direction: column;

	overscroll-behavior: none;

	overflow: scroll;

	overflow-x: hidden;

	background-color: rgba(2, 9, 22, 1);
}

.menu-margin {
	margin-bottom: calc(115px + var(--tg-safe-area-inset-bottom, 0px));
}

.wallet-background {
	background-image: url('@/assets/images/142.png');
	background-repeat: no-repeat;
	background-size: 100% auto;
	background-attachment: fixed;
	background-position: bottom;
}

.earn-background {
	background-image: url('@/assets/images/lighting-background.svg');
	background-repeat: no-repeat;
	background-size: 100% auto;
	background-attachment: fixed;
}
</style>
